// extracted by mini-css-extract-plugin
export default {"content":"Account_content__ETR1W"};